/**
 * Finds the Nav 4 panel's range `input` that the splitter uses to resize the
 * enclosing layout slot, starting from an element inside the panel. Returns
 * `null` when the element is not inside a resizable panel section.
 */
export const findPanelResizeInput = (fromElement: HTMLElement | null): HTMLInputElement | null => {
	if (!fromElement) {
		return null;
	}

	const panelSection = fromElement.closest('section[data-layout-slot]');
	if (!panelSection) {
		return null;
	}

	return panelSection.querySelector<HTMLInputElement>('input[type="range"]');
};
